import { SKILLS } from '../data/site'
import { Reveal } from './Reveal'
import { Section } from './Section'
import styles from './Skills.module.css'

export function Skills() {
  return (
    <Section
      id="skills"
      eyebrow="Skills"
      title="What I bring to a team."
      lead="Leadership is the job. Staying technical is what makes the leadership credible."
    >
      <div className={styles.grid}>
        {SKILLS.map((group, i) => (
          <Reveal key={group.name} delay={Math.min(i * 70, 240)}>
            <div className={styles.group}>
              <h3 className={styles.groupName}>{group.name}</h3>
              <ul className={styles.tags}>
                {group.items.map((item) => (
                  <li key={item} className={styles.tag}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  )
}
